import { tsValidateArray, tsValidateBoolean, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { DBDef_Variable, knowledgeManagerDBGroup } from '@app/hcs-shared';
import { Validator_AdvisorWizardConfig } from '../../_enum/index.js';
const Validator_WizardStepSnippet = {
    snippetId: tsValidateUniqueId,
    resolvedVariableId: tsValidateOptionalId,
};
const Validator_WizardStepViewData = {
    isActive: tsValidateBoolean(),
    overwriteSnippets: tsValidateBoolean(),
    snippets: tsValidateArray(Validator_WizardStepSnippet),
};
const Validator_WizardStep = {
    label: tsValidateString(),
    snippets: tsValidateArray(Validator_WizardStepSnippet),
    formData: Validator_WizardStepViewData,
    searchData: Validator_WizardStepViewData,
    freeTextData: Validator_WizardStepViewData,
};
const Validator_ModifiableProps = {
    label: tsValidateString(),
    steps: tsValidateArray(Validator_WizardStep),
    config: Validator_AdvisorWizardConfig,
    renderedLabel: tsValidateString(undefined, false),
};
const Validator_GeneratedProps = {
    __snippetIds: tsValidateArray(tsValidateUniqueId),
    __variableIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_AdvisorWizard = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'advisor-wizard',
    entityName: 'advisor-wizard',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'advisor-wizard'
    },
    backend: {
        name: 'advisor-wizard'
    },
    dependencies: {
        __snippetIds: { dbKey: 'advisor-context', fieldType: 'string[]' },
        __variableIds: { dbKey: DBDef_Variable.dbKey, fieldType: 'string[]' },
    }
};
//# sourceMappingURL=db-def.js.map